import { styled } from '@mui/material/styles';
import { Box, Paper, Button } from '@mui/material';

export const UnauthorizedContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '100vh',
  background: 'linear-gradient(135deg, #0d1828 0%, #162238 100%)',
  padding: '20px',
});

export const ContentWrapper = styled(Paper)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '48px 32px',
  maxWidth: '500px',
  width: '100%',
  borderRadius: '12px',
  backgroundColor: '#1E2E46',
  boxShadow: '0 8px 24px rgba(0, 0, 0, 0.2)',
  gap: '24px',
});

export const IconWrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '80px',
  height: '80px',
  borderRadius: '50%',
  backgroundColor: 'rgba(244, 67, 54, 0.1)',
  marginBottom: '8px',
  color: '#f44336',
});

export const TitleText = styled(Box)({
  fontSize: '24px',
  fontWeight: 'bold',
  color: 'white',
  textAlign: 'center',
  marginBottom: '8px',
});

export const MessageText = styled(Box)({
  fontSize: '16px',
  color: 'rgba(255, 255, 255, 0.7)',
  textAlign: 'center',
  maxWidth: '400px',
  lineHeight: 1.6,
});

export const StyledButton = styled(Button)({
  marginTop: '8px',
  padding: '10px 24px',
  borderRadius: '8px',
  fontWeight: 'bold',
  textTransform: 'none',
  fontSize: '16px',
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  '&.primary': {
    backgroundColor: '#2196f3',
    color: 'white',
    '&:hover': {
      backgroundColor: '#1976d2',
    },
  },
  '&.secondary': {
    backgroundColor: 'rgba(255, 255, 255, 0.08)',
    color: 'white',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.12)',
    },
  },
});

export const ButtonsContainer = styled(Box)({
  display: 'flex',
  gap: '16px',
  marginTop: '8px',
  width: '100%',
  justifyContent: 'center',
});
